import React from "react";
// Adjust path to your image
import logo from "../../assests/images/family-soccer.jpeg";
import { Box, Typography, Container, Divider } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

const AboutCandidate = () => {
  const timelineData = [
    {
      label: "EDUCATION",
      content:
        "Bachelor of Arts from University of Delaware, Masters in Education from Wilmington University, and graduate of the NJSACP West Point Command and Leadership Program.",
    },
    {
      label: "15 YRS",
      content: (
        <>
          <strong>HOA President</strong> - Served as community HOA president for
          15 years. This is how I understand leadership: listening, resolving
          disputes, putting community first.
        </>
      ),
    },
    {
      label: "20 YRS",
      content: (
        <>
          <strong>New Castle County PD</strong> - Retired Senior Sergeant. First
          full-time detective assigned to Middletown. I have a strong
          understanding of the importance of building relationships between the
          community and policing.
        </>
      ),
    },
    {
      label: "15 YRS",
      content: (
        <>
          <strong>Delaware Dept. of Justice</strong> - Criminal Investigator
          then Director, Victim Witness Assistance Program. Advocacy,
          accountability, fairness.
        </>
      ),
    },
    {
      label: "FAMILY",
      content: (
        <>
          <strong>Michelle, Jordan, Ryan & Marissa</strong> - All three kids
          through Appoquinimink schools. Jordan's IEP experience gives us
          firsthand knowledge of what families with disabilities face in our
          district.
        </>
      ),
    },
  ];

  return (
    <Box sx={{ py: 10, bgcolor: "#FDFBF7", minHeight: "100vh" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 6, md: 4 },
            alignItems: "flex-start",
          }}
        >
          {/* Left Column: Text and Timeline */}
          <Box sx={{ flex: { md: 1.2 }, width: "100%" }}>
            <Typography
              sx={{
                color: "#C59324",
                fontWeight: 700,
                letterSpacing: "0.2em",
                fontSize: "0.85rem",
                textTransform: "uppercase",
                mb: 2,
              }}
            >
              About the Candidate
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#051328",
                fontWeight: 700,
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                lineHeight: 1.1,
              }}
            >
              A Lifelong Delawarean
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#C59324",
                fontStyle: "italic",
                fontWeight: 500,
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                mb: 3,
                lineHeight: 1.1,
              }}
            >
              Fighting for You
            </Typography>

            <Typography
              sx={{
                color: "#555",
                mb: 6,
                lineHeight: 1.8,
                fontSize: "1.05rem",
                maxWidth: "600px",
              }}
            >
              57 years old. Born and raised in Delaware. This is the only home I
              have ever known. 30 years in Middletown. This community is not a
              campaign stop; it's where I built my life.
            </Typography>

            {/* Timeline Rows */}
            {timelineData.map((item, index) => (
              <Box key={index}>
                <Divider sx={{ borderColor: "rgba(0,0,0,0.08)" }} />
                <Box
                  sx={{
                    display: "flex",
                    py: 4,
                    gap: 2,
                    alignItems: "baseline",
                  }}
                >
                  {/* Label Part */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      minWidth: { xs: "100px", md: "150px" },
                    }}
                  >
                    <CircleIcon sx={{ fontSize: 8, color: "#B48B3D" }} />
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#B48B3D",
                        letterSpacing: 1.5,
                        fontSize: "0.75rem",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>

                  {/* Content Part */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        color: "#444",
                        lineHeight: 1.7,
                        fontSize: "0.95rem",
                      }}
                    >
                      {item.content}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Right Column: Photo Section */}
          <Box
            sx={{
              flex: { md: 0.8 },
              width: "100%",
            }}
          >
            <Box
              sx={{
                bgcolor: "#FFF",
                p: 1,
                pb: 2,
                borderRadius: "8px",
                boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
                border: "1px solid rgba(0,0,0,0.05)",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Family Photo"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: "6px",
                }}
              />
              <Box
                sx={{
                  mt: 2,
                  px: 2,
                  py: 1,
                  borderLeft: "2px solid #B48B3D",
                  ml: 1,
                }}
              >
                <Typography
                  sx={{
                    fontStyle: "italic",
                    color: "#666",
                    fontSize: "0.75rem",
                    lineHeight: 1.5,
                  }}
                >
                  "My family is why I'm running. Every decision I make will be
                  measured by how it affects families like ours."
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutCandidate;
